import React from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { withAppStorage } from '../utils/appStorage';
import { Loader } from '../components/Loader';
import { Error } from '../components/Error';
import { TransitionWrapper } from '../components/TransitionWrapper';

import GenerateMetaTags from '../components/GenerateMetaTags';
import Breadcrumbs from '../components/Breadcrumbs';
import Article, { Title, Content } from '../components/Article';
import GuidanceNotice from '../components/GuidanceNotice';
import KlarnaCheckout from '../components/KlarnaCheckout';

const GET_KLARNA_CHECKOUT = gql`
  query getKlarnaCheckout($cartId: String! $regNumber: String) {
    checkout: getKlarnaCheckout(cartId: $cartId regNumber: $regNumber) {
      html_snippet
    }
  }
`;

export default withAppStorage(function CartPage({ appStorageData }) {
  return (
    <TransitionWrapper>
      <Helmet>
        {GenerateMetaTags({
          title: 'Klarna checkout',
          description: 'Betal her.'
        })}
      </Helmet>

      <Breadcrumbs breadcrumbs={null} />

      <Article>
        <Title>Klarna</Title>
        <Content wide>
          <Query
            query={GET_KLARNA_CHECKOUT}
            fetchPolicy="network-only"
            variables={{
              cartId: appStorageData.cartId,
              regNumber: appStorageData.regNumber
            }}
          >
            {({ data, error, loading }) => {
              if (loading) {
                return <Loader />;
              }

              if (error) {
                return <Error error={error} />;
              }

              if (data && data.checkout) {
                return <KlarnaCheckout checkout={data.checkout} />;
              }

              return (
                <div style={{ textAlign: 'center' }}>
                  <h2>Ingen handlekurv ble funnet!</h2>
                </div>
              );
            }}
          </Query>
        </Content>
      </Article>

      <GuidanceNotice />
    </TransitionWrapper>
  );
});
